import { createActions, createReducer } from 'reduxsauce'

import DetalhesEmpenhoService from '../../servicos/DetalhesEmpenhoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaBaseLegalEmpenhoInicio: [],
    buscaBaseLegalEmpenhoSucesso: ['baseLegalEmpenho'],
    buscaBaseLegalEmpenhoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: null,
    selecionado: null,
}

// Ação para busca completa
Creators.buscaBaseLegalEmpenho = filtro => {
    return dispatch => {
        dispatch(Creators.buscaBaseLegalEmpenhoInicio())
        let serv = new DetalhesEmpenhoService()
        return serv
            .consultarBaseLegal(filtro)
            .then(response => dispatch(Creators.buscaBaseLegalEmpenhoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaBaseLegalEmpenhoErro(error)))
    }
}

const buscaBaseLegalEmpenhoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaBaseLegalEmpenhoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaBaseLegalEmpenhoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.baseLegalEmpenho, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_BASE_LEGAL_EMPENHO_INICIO]: buscaBaseLegalEmpenhoInicio,
    [Types.BUSCA_BASE_LEGAL_EMPENHO_ERRO]: buscaBaseLegalEmpenhoErro,
    [Types.BUSCA_BASE_LEGAL_EMPENHO_SUCESSO]: buscaBaseLegalEmpenhoSucesso,
})
